class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this._loadStarted = false;
  }

  connectedCallback() {
    const run = () => this.loadRecommendations();

    this._detailsRef = this.closest('details');
    if (this._detailsRef) {
      this._onDetailsToggle = () => {
        if (this._detailsRef.open) run();
      };
      this._detailsRef.addEventListener('toggle', this._onDetailsToggle);
      if (this._detailsRef.open) run();
    }

    this._onDrawerOpened = () => run();
    document.addEventListener('cartdrawer:opened', this._onDrawerOpened);

    const scrollRoot = this.closest('.mini-cart__main') || null;

    this._io = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        run();
      },
      {
        root: scrollRoot,
        rootMargin: '200px 0px 400px 0px',
        threshold: 0.01,
      }
    );
    this._io.observe(this);

    requestAnimationFrame(() => {
      if (!this._loadStarted && this._detailsRef && this._detailsRef.open) run();
    });
  }

  disconnectedCallback() {
    if (this._detailsRef && this._onDetailsToggle) {
      this._detailsRef.removeEventListener('toggle', this._onDetailsToggle);
    }
    if (this._onDrawerOpened) {
      document.removeEventListener('cartdrawer:opened', this._onDrawerOpened);
    }
    if (this._io) {
      this._io.disconnect();
    }
  }

  loadRecommendations() {
    if (this._loadStarted || !this.dataset.url) return;
    this._loadStarted = true;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const sectionRoot = doc.querySelector('.shopify-section') || doc.body;
        if (sectionRoot === null) return;

        const recommendations = sectionRoot.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
        this._loadStarted = false;
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
